var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"unraid-svg-icon",class:_vm.symbolClass,attrs:{"symbol":_vm.symbol,"role":"presentation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }